import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchRSim } from 'rSimInventory/RSimApi/rSimApi';
import { rsimProductDetailsQueries } from '../Details/utils/rsimProductDetailsQueries';

export const useRSimSuspenseQuery = (euicc: string) => {
  return useSuspenseQuery({
    queryKey: rsimProductDetailsQueries.detail({ euicc }),
    queryFn: () => {
      return fetchRSim(euicc);
    },
    refetchOnWindowFocus: true,
  });
};
